export default __webpack_public_path__ + "static/media/setting-icon.6ce8248b.svg";